import CashCollectionSearchRequestBase from './base/CashCollectionSearchRequestBase';

/**
 * @class CashCollectionSearchRequest
 * @extends CashCollectionSearchRequestBase
 */
class CashCollectionSearchRequest extends CashCollectionSearchRequestBase {

}

export default CashCollectionSearchRequest;
